import { render, staticRenderFns } from "./payoutsTab.vue?vue&type=template&id=d7bcea66&scoped=true&"
import script from "./payoutsTab.vue?vue&type=script&lang=js&"
export * from "./payoutsTab.vue?vue&type=script&lang=js&"
import style0 from "./payoutsTab.vue?vue&type=style&index=0&id=d7bcea66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bcea66",
  null
  
)

export default component.exports